/* eslint-disable camelcase */
import React, { FC, useCallback, useEffect, useMemo, useState } from "react"
import SyncableModel from "../../../../database/SyncableModel";
import { Appearance } from "react-native"
import { CompositeScreenProps } from "@react-navigation/native"
import { Cycle } from "../../../../database"
import { CycleCloseForm as ModelForm, ModelCreateScreen} from "../../../../components"
import { observer } from "mobx-react-lite"
import { useStores } from "../../../../models"

export const CycleCloseScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function CycleCloseScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params = {} } } = props

  // Pull in one of our MST stores
  const {
    appStore: { farmId, farmStore },
    cycleStore: modelStore
  } = useStores();

  const [ model, setModel ] = useState<SyncableModel>(null)

  const initialValues = useMemo<any>(() => {
    const data = (model ? model.toArray() : params)
    return {
      farm_id: farmId,
      ...data
    }
  }, [farmId, model, params])

  useEffect(() => {
    const cycle = farmStore.cycles.find((m) => m.id === params.id);
    if (cycle) {
      const model = new Cycle();
      const attributes = { ...cycle }
      Object.keys(attributes).forEach((k) => {
        model.setAttribute(k, attributes[k])
      })
      model.syncOriginal();
      model.exists = true
      setModel(model)
    }
  }, [farmStore, params.id, setModel])

  const onSuccess = useCallback((success: boolean) => {
    if (modelStore.needRefresh) {
      if (success) {
        farmStore.initWithLastBatch(() => {
          modelStore.set('needRefresh', false);
          modelStore.set('pushIdQueue', {})
        });
      } else {
        modelStore.set('needRefresh', false);
        modelStore.set('pushIdQueue', {})
      }
    }
    return success;
  }, [farmStore, modelStore])

  return (
    <ModelCreateScreen
      colorScheme={colorScheme}
      ModelForm={ModelForm}
      initialValues={initialValues}
      modelStore={modelStore}
      model={model}
      onSuccess={onSuccess}
      saveTx="cycleCloseScreen.title"
      denyDelete
    />
  )
})
